<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <p class="mt-5">
            Die geschwungene Form der 7m langen und fugenlosen Empfangsplastik aus Acrylstein integriert formal die ergonomischen Anforderungen an den Arbeitsplatz. Das skulpturale und zeitgenössische Objekt verbindet eine dynamische und zeitgenössische Formensprache mit funktionalen und ergonomischen Anforderungen. Das biomorphe Objekt bildet den Ausgangspunkt für das gestalterische Gesamtkonzept der Arztpraxis. Die organische Formensprache, die Materialität und die Idee der Bewegung und Linienführung setzen sich in der Raumgestaltung fort. Die gekrümmten Glasflächen flankieren die Empfangsplastik und entwickeln sich von dort als Orientierungshilfe in den Raum und zu den Behandlungsräumen. Die Glasflächen werden in transparente, transluzente und opake Bereiche ausdifferenziert. Dadurch können Funktionsbereiche mit unterschiedlichen Anforderungen an Transparenz oder Geschlossenheit geschaffen werden. Die Materialien Glas, Acrylstein und Aluminium bestimmen auch das Gesamterscheinungsbild der Architektur. Ein freigestellter Kubus aus Aluminium integriert den Röntgenraum und die zentrale Versorgung. Die gelbgold-eloxierten Metalloberflächen zitieren mit ihrem warmen und zugleich technischen Grundton die Funktion.
        </p>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            :link="links[9]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            :link="links[10]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            :link="links[11]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            :link="links[12]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            :link="links[13]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <!-- <tailwind-image
            :link="links[14]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image> -->
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Markus Holzbach mit Spacekitchen</p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/dentalfit_15_a.jpg' ),
                require( '@/assets/img/pc/zahnarztpraxiskoblenz_5.jpg' ),
                require( '@/assets/img/pc/dentalfit_1_b.jpg' ),
                require( '@/assets/img/pc/dentalfit_3_b.jpg' ),
                require( '@/assets/img/pc/dentalfit_6_b.jpg' ),
                require( '@/assets/img/pc/dentalfit_7_b.jpg' ),
                require( '@/assets/img/pc/dentalfit_11_a.jpg' ),
                require( '@/assets/img/pc/dentalfit_12_a.jpg' ),
                require( '@/assets/img/pc/dentalfit_14_a.jpg' ),
                require( '@/assets/img/pc/dentalfit_2_a.jpg' ),
                require( '@/assets/img/pc/dentalfit_16_a.jpg' ),
                require( '@/assets/img/pc/zahnarztpraxis_1.jpg' ),
                // require('@/assets/img/pc/zahnarztpraxis_2.jpg'),
                require( '@/assets/img/pc/zahnarztpraxis_6.jpg' ),
                require( '@/assets/img/pc/zahnarztpraxiskoblenz_1.jpg' ),
            ]
        };
    },
    methods: {},
    created () { },
};
</script>